import { usePathname } from "next/navigation";
import { useEffect, useState, useRef } from "react";

const IPLYearsCarousel = ({
  matchData,
  handleSelectYear,
  selectedYear,
  setTourId,
}) => {
  const pathname = usePathname();
  const isWinnerPage = pathname?.includes("cap");
  const isFielding = pathname?.includes("fielding-");
  const scrollContainerRef = useRef(null);

  const [matches, setMatches] = useState(matchData);
  const [activeYear, setActiveYear] = useState(selectedYear);

  useEffect(() => {
    // Scroll horizontally to the selected year without affecting vertical scroll
    const element = document.getElementById(`${selectedYear}_1`);
    if (element && scrollContainerRef.current) {
      const scrollContainer = scrollContainerRef.current;
      const elementLeft =
        element.offsetLeft -
        scrollContainer.offsetLeft -
        scrollContainer.clientWidth / 2 +
        element.clientWidth / 2;
      scrollContainer.scrollTo({ left: elementLeft, behavior: "smooth" });
    }
  }, [selectedYear]);

  return (
    <div className="w-full my-8 overflow-hidden">
      {" "}
      {/* Hide Y-axis overflow */}
      {matches && (
        <div className="w-full p-1">
          <div
            ref={scrollContainerRef}
            className="w-full flex items-center gap-2 overflow-x-auto hide-scrollbar"
            style={{
              overflowY: "hidden", // Make sure Y-axis scroll is hidden
              scrollBehavior: "smooth",
              WebkitOverflowScrolling: "touch",
            }}
          >
            <div className="flex space-x-2">
              {Object.keys(matches)
                .sort((a, b) => Number(b) - Number(a))
                .map((value, index) => {
                  const isActive = activeYear == value;
                  const className = isActive
                    ? `py-2 px-4 rounded-lg text-sm font-semibold bg-primary text-white cursor-pointer`
                    : `py-2 px-4 rounded-lg text-sm font-semibold border-2 text-gray-800 hover:text-primary cursor-pointer`;

                  const handleClick = () => {
                    handleSelectYear(value);
                    setTourId(matchData[value]);
                    setActiveYear(value);
                  };

                  const basePath = pathname
                    ?.replace(/-winner-\d{4}$/, "")
                    ?.replace(/-\d{4}$/, "");

                  return isWinnerPage ? (
                    <a
                      id={`${value}_1`}
                      key={index}
                      href={`${basePath}-winner-${value}`}
                      className={className}
                      onClick={handleClick}
                    >
                      {value}
                    </a>
                  ) : isFielding ? (
                    <a
                      id={`${value}_1`}
                      key={index}
                      href={`${basePath}-${value}`}
                      className={className}
                      onClick={handleClick}
                    >
                      {value}
                    </a>
                  ) : (
                    <div
                      id={`${value}_1`}
                      key={index}
                      className={className}
                      onClick={handleClick}
                    >
                      {value}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default IPLYearsCarousel;
